import React from "react";
import * as Type from "../../../../../../common-deprecated/styles/v2/toyota/globals/Type";
import useETADeliveryLabel from "../../../hooks/shared/useETADeliveryLabel";

type ETAPropsType = {
    date?: string | false;
};

const ETADeliveryLabel = ({ date }: ETAPropsType): JSX.Element | null => {
    const label = useETADeliveryLabel(date);
    if (!label) return null;

    return (
        <Type.Text as="div" headingType="milli" styleType="headline" noUppercase mb={0}>
            {label}
        </Type.Text>
    );
};

export default ETADeliveryLabel;
